import React, { useEffect } from "react";
import { Dropdown } from "@lwt-helix/dropdown";
import { useCommonStore, useSearchStore } from "../../store/store";
import { viewTypes } from "../constants";

const OfficesDropdown = () => {

    const {
        selectedMls,
        selectedOffice,
        setSelectedOffice,
        viewTypeId,
    } = useSearchStore(state => ({
        selectedMls: state[state.selectedModule]?.selectedMls,
        selectedOffice: state[state.selectedModule]?.selectedOffice,
        setSelectedOffice: state.setSelectedOffice,
        viewTypeId: state[state.selectedModule]?.viewTypeId,
    }));

    const {
        officesInfo,
    } = useCommonStore(state => ({
        officesInfo: [...(Array.isArray(state.officeInfo) ? state.officeInfo : [])]
            .sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase()))
            .filter(o => o?.isOfficeActive && o.mlsOfficeId.mlsId === selectedMls?.mlsId)
    }));

    useEffect(() => {
        if (!officesInfo?.length) return;
        const defaultOffice = [...officesInfo].filter(o => o.mlsOfficeId.mlsId === selectedMls?.mlsId)[0];
        setSelectedOffice(defaultOffice);
    }, [selectedMls?.mlsId]);

    const officeOptions = officesInfo.map((office, i) => ({
        dataLwtId: `${i}-office-item-${office.mlsOfficeId.officeId}`,
        itemText: office.name,
        key: `${i}-office-${office.mlsOfficeId.officeId}`,
        onClick: () => setSelectedOffice(office),
    }));

    return <>
        {viewTypeId === viewTypes.byOffice.id &&
            <Dropdown
                dataLwtId="offices-dropdown"
                items={officeOptions}
                menuProps={{
                    dataLwtId: "share-menu",
                    right: true,
                    className: "office-menu-dropdown"
                }}
                toggleProps={{
                    dataLwtId: "no-split-toggle",
                    id: "caret",
                    color: "secondary",
                    caret: true,
                    children: selectedOffice?.name,
                    className: "btn btn-sm btn-secondary mb-1 mr-2",
                }}
            />
        }
    </>
    ;
};

export default OfficesDropdown;
